<template>
  <div :class="custom_class" class="container-accordion-form" id="accordion">
    <div class="container-accordion-form">
      <div class="card ba-w-100">
        <div class="card-header" id="group-editing">
          <span class="py-1 d-block" data-toggle="collapse" :data-target="`#collapse-group-editing`"
            aria-expanded="true" :aria-controls="`collapse-group-editing`">{{ `${group.name}` }}
            <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
          </span>
        </div>
        <div :id="`collapse-group-editing`" :aria-labelledby="`group-editing`" class="collapse show" data-parent="#accordion">
          <div class="card-body ba-w-100">
            <div class="form-group tags-separator" v-for="(tag, index) in tags" v-bind:key="index" v-if="tag.id <= 16">
              <label :for="`tag-${index}`" class="ba-custom-label w-100">{{ tag.name }}
                <font-awesome-icon class="font-awesome-icon" style="color: #9DB3CC;" :icon="['fas', 'question-circle']"
                  v-tooltip="{ content: $t(tag.description), class: 'tooltip-custom' }" />
              </label>
              <textarea v-if="tag.name === 'describe-the-difference'" :placeholder="$t(tag.example)"
                v-model="group.tags[tag.id]" class="ba-textarea ba-w-100" :name="`tag-${index}`" rows="10" style="resize: none"
                :id="`tag-${group.id}-${index}`">
                      </textarea>
              <input v-else type="text" :placeholder="$t(tag.example)" v-model="group.tags[tag.id]" class="ba-input ba-w-100"
                :name="`tag-${index}`" :id="`tag-${group.id}-${index}`">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-accordion-form">
      <div class="card mb-4">
        <div class="card-header" :id="`group-tag`">
          <span class="py-1 d-block collapsed" data-toggle="collapse" :data-target="`#collapse-group-tag`"
            aria-expanded="false" :aria-controls="`collapse-group-tag`">{{ $t('ct-advanced-tags') }}
            <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
          </span>
        </div>
        <div :id="`collapse-group-tag`" class="collapse" :aria-labelledby="`group-tag`" data-parent="#accordion">
          <div class="card-body tags-group">
            <div class="form-group tags-separator" v-for="(tag, index) in tags" v-bind:key="tag.id" v-if="tag.id > 16">
              <label :for="`tag-${index}`" class="w-100 ba-custom-label">
                {{ tag.name }}
                <font-awesome-icon class="font-awesome-icon" style="color: #9DB3CC;" :icon="['fas', 'question-circle']"
                  v-tooltip="{ content: $t(tag.description), class: 'tooltip-custom' }" />
              </label>
              <input type="text" :placeholder="$t(tag.example)" v-model="group.tags[tag.id]" class="ba-input ba-w-100"
                :name="`tag-${index}`" :id="`tag-${group.id}-${index}`">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagsItem',
  props: ['group', 'tags', 'custom_class']
};
</script>

<style lang="scss" scoped>
.place-inputs {
  background-color: white;
  border: none;
  padding: 50px;
}

.tags-separator {
  margin-bottom: 30px;
}

.form-control {
  background-color: #FAFBFC;
  border-color: #E2E4E9;
}

@media (max-width: 990px) {

  .place-helpers {
    width: 100% !important;
    text-align: center;

    * {
      text-align: center !important;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/TagsItem.vue